/* global modForm Modalytics */
export function addServiceCodeToHeap() {
	const isServiceCodeUpdated = modForm.opts.initialServiceCode && modForm.opts.vertical && modForm.opts.initialServiceCode !== modForm.opts.vertical;
	if ((modForm.opts && modForm.opts.vertical && !modForm.opts.isServiceCodeStampedInHeap) || isServiceCodeUpdated) {
		modForm.opts.initialServiceCode = modForm.opts.vertical;
		const properties = {
			'serviceCode': modForm.opts.vertical
		};
		Modalytics.heap('addEventProperties', properties);
		Modalytics.heap('addUserProperties', properties);
		modForm.opts.isServiceCodeStampedInHeap = true;
	}
}
